module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Hvilket livsområde hører til dette ikonet?"},"en":{"title":"Which lifeskill is this icon?"}}')
  delete Component.options._Ctor
}
